import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { customFetchV2 } from '../services/custom-fetch-v2';
import { DeviceFull } from './useGetCurrentUserDevices';

interface UseGetCurrentUserDevicesParams {
  deviceId: string;
}

/**
 * API query to retrieve user info.
 */
const getDevice = async (deviceId: string): Promise<DeviceFull | null> => {
  const response: any = await customFetchV2<DeviceFull>(`/api/v2/devices/${deviceId}`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('Unable to get user devices');
  }

  return response.data;
};

/**
 * React hook that will fetch and refresh the logged in users devices.
 */
const useGetDevice =
  ({ deviceId }: UseGetCurrentUserDevicesParams): UseQueryResult<DeviceFull, unknown> =>
    useQuery(['useGetDevice', deviceId], () => getDevice(deviceId), {
      enabled: true,
      retry: false,
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
    });

/** Exports */
export { useGetDevice };
